import React, { useState } from 'react';

//interfaces
import { IAddTermModal, IWhitelistTerm } from 'interfaces/languages';

//components
import { BasicButton, BasicTextInput, ThriveModal } from 'thrive-components';

//styles
import "../../../../css/modals/addTermModal.scss";



const  AddTermModal = ({showModal, termInformation, onSaveClick, onCloseClick}:IAddTermModal) => {
    if (!showModal) { return <></> }

    const maxTextLength = 280;
    const maxDescriptionLength = 1024;
    const [newTerm, setNewTerm] = useState<IWhitelistTerm>(termInformation ?? { id: 0, text: "", description: "" } );    
    const showTermError = newTerm?.text && newTerm?.text.length > maxTextLength;
    const showDescriptionError = newTerm?.description && newTerm?.description.length > maxDescriptionLength;

    return (
        <ThriveModal 
            showModal
            className={`add-term-modal`}
            headerContent={<h1 className='add-term-header'>Add Term</h1>} 
            bodyContent={
                <div className='add-term-modal-body'>
                    <BasicTextInput
                        className={`add-term-input ${showTermError ? "error-wrapper" : ""}`}
                        labelText='TERM'
                        textString={newTerm?.text ?? ""} 
                        setTextString={(value) => setNewTerm(prev => ({ ...prev, text: value }))} 
                        placeholderText={'Add a word or phrase'}
                    />
                    {showTermError &&
                        <span className='term-error-message'>Please enter a maximum of {maxTextLength} characters</span>
                    }

                    <BasicTextInput
                        className={`add-description-input ${showDescriptionError ?"error-wrapper" : ""}`}
                        labelText='DESCRIPTION (OPTIONAL)'
                        textString={newTerm?.description ?? ""}
                        setTextString={(value) => setNewTerm(prev => ({ ...prev, description: value }))} 
                        placeholderText={'Add context for internal reference'}
                    />
                    {showDescriptionError &&
                        <span className='term-error-message'>Please enter a maximum of {maxDescriptionLength} characters</span>
                    }
                </div>
            } 

            footerContent={
                <div className="add-term-modal-footer">
                    <BasicButton 
                        className='save-term-button'
                        onButtonClick={()=>onSaveClick(newTerm)}
                        content={"Save"} 
                        ariaLabel={'Save changes and add term'}
                        isDisabled={!newTerm.text}                   
                    />
                </div>
            } 
            onCloseClick={onCloseClick}
        />
    );
};

export default AddTermModal;